<div>
  <div class="col-sm-12" style="padding: 0 !important" *ngIf="!loadingConfigPattern">
    <div class="form-row">
      <div class="form-group col-sm-6">
        <label>Base URL <span class="obrigatorio" style="line-height: 0;">*</span></label>
        <input type="text" class="form-control" [(ngModel)]="config.baseurl" />
      </div>
      <div class="form-group col-sm-6">
        <label>Código <span class="obrigatorio" style="line-height: 0;">*</span></label>
        <input type="text" class="form-control" [(ngModel)]="config.codigo" />
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-sm-6">
        <label>Cliente padrão para venda <span class="obrigatorio">*</span></label>
        <div class="participant-container">
          <p> {{ codigoCliente ? codigoCliente + ' - ' + nomeFantasiaCliente : 'NÃO INFORMADO' }} </p>
          <span class="material-icons" (click)="loadCliente(1)" matTooltip="Alterar Cliente">edit</span>
        </div>
      </div>
      <div class="form-group col-sm-6">
        <label>Operação padrão para venda <span class="obrigatorio">*</span></label>
        <p-dropdown appendTo="body" class="type-p-dropdown" [filter]="true" [virtualScroll]="true" [itemSize]="30"
          placeholder="Selecione" [options]="optOperation" emptyMessage="Nenhum resultado encontrado!"
          [dropdownIcon]="loadingIconOptOper ? 'pi pi-spinner pi-spin' : 'pi pi-chevron-down'"
          [(ngModel)]="config.operacao_padrao_id"></p-dropdown>
      </div>
    </div>
  </div>
  <div class="col-sm-12 loading-content" style="padding: 0 !important" *ngIf="loadingConfigPattern">
    <p><span class="material-icons rotate">hourglass_empty</span> <b>Carregando informações da conta ...</b></p>
  </div>
</div>

<app-modal-participante [(isVisible)]="modalParticipante" (onSelectParticipant)="salvarCliente($event)"
  [participanteTipoId]="tipoParticipanteId">
</app-modal-participante>